import {createStore} from 'vuex'
import snackbar from './snackbar'
const store = createStore({
    state: {
        tasksRevision: 0,
        authenticated: false,
        token: '',
        baseUrlAPi: window.appConfig.API_URL,
        baseUrlAPi2: window.appConfig.API_URL2,
        mobileNumber: '',
        userData: '',
        checkedNodes: [],
        removedNode: {},
        logout: false,
        disableInput: true,
        withoutLayout: false,
        numberqarecords: 0,
        otpEnabled:'0',
        numberportal: 0,
        panelRole : null,
        active_operator:0,
        formData: null,
        apiClients:null,

    },
    getters: {
        getFormData: (state) => state.formData,
        getApiClients: (state) => state.apiClients,
        getUserData: (state) => state.userData,
        getWithoutLayout: (state) => state.withoutLayout,
        getOtpEnabled: (state) => state.otpEnabled,
        getActiveOperator: (state) => state.active_operator,
        getPanelRole: (state) => state.panelRole,
        getLogOut: (state) => state.logout,
        checkedNodes: (state) => state.checkedNodes,
        getremovedNode: (state) => state.removedNode,
        getdisableInput: (state) => state.disableInput,
        getnumberqarecords: (state) => state.numberqarecords,
        getnumberportal: (state) => state.numberportal,
        isAuthenticated:(state) => state.authenticated,
        getMobile(state) {
            return state.mobileNumber
        },
        baseUrl(state) {
            return state.baseUrlAPi
        },
        baseUrl2(state) {
            return state.baseUrlAPi2
        },
    },
    mutations: {
        notifyTaskSaved(state) {
            state.tasksRevision += 1
        },
        SET_FORM_DATA(state, data) {
            state.formData = data
        },
        SET_API_CLIENT(state, data) {
            state.apiClients = data
        },
        SET_FORM_DATA_FIELD(state, { key, value }) {
            const keys = key.split('.')
            let target = state.formData

            keys.slice(0, -1).forEach(k => {
                target = target[k]
            })

            target[keys[keys.length - 1]] = value
        },
        setActiveOperator(state, item) {
            state.active_operator = item
        },
        setPanelRole(state, item) {
            state.panelRole = item
        },
        setLogin(state,item) {
            state.authenticated = item
        },
        setWithoutLayout(state,item) {
            state.withoutLayout = item
        },
        setUserData(state, data) {
            state.userData = data;
        },
        setLogout(state , value) {
            state.logout = value;
        },
        setMobile(state, mobile) {
            state.mobileNumber = mobile
        },
        setcheckedNodes(state, node) {
            state.checkedNodes.push(node)
        },
        removecheckedNodes(state, index) {
            state.checkedNodes.splice(index, 1)
        },
        setremovedNode(state, item) {
            state.removedNode = item
        },
        setdisableInput(state, item) {
            state.disableInput = item
        },
        setnumberportal(state, item) {
            state.numberportal = item
        },
        setnumberqarecords(state, item) {
            state.numberqarecords = item
        },
        setOtpEnabled(state,item){
            state.otpEnabled = item
        }
    },
    actions: {
        setFormData({ commit }, data) {
            commit('SET_FORM_DATA', data)
        },
        setApiClient({ commit }, data) {
            commit('SET_API_CLIENT', data)
        },

        updateFormField({ commit }, { key, value }) {
            commit('SET_FORM_DATA_FIELD', { key, value })
        },
        updateUserData({commit}, data) {
            commit('setUserData', data);
        },
        logout({commit}) {
            commit('setLogout');
        },
        saveWithoutLayout({commit}) {
            commit('setWithoutLayout');
        },
        saveOtpEnabled({commit}) {
            commit('setOtpEnabled');
        },

        saveActiveOperator({commit}, newVal) {
            commit('setActiveOperator', newVal);
        },
        savePanelRole({commit}, newVal) {
            commit('setPanelRole', newVal);
        },
        saveLogin({commit}, newVal) {
            commit('setLogin', newVal);
        },
        setMobile({commit}, newVal) {
            commit('setProfile', newVal);
        },
        savecheckedNodes({commit}, newVal) {
            commit('setcheckedNodes', newVal);
        },
        saveremovedNode({commit}, newVal) {
            commit('setremovedNode', newVal);
        },
        savedisableInput({commit}, newVal) {
            commit('setdisableInput', newVal);
        },
        savenumberqarecords({commit}, newVal) {
            commit('setnumberqarecords', newVal);
        },
        savenumberportal({commit}, newVal) {
            commit('setnumberportal', newVal);
        },
    },
    modules: {
        snackbar
    }
})

export default store;
